import { __assign } from "tslib";
import * as React from 'react';
import { memo } from 'react';
var SvgPlay = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", "data-test-id": "icons-play", viewBox: "0 0 24 24", role: "img" }, props),
    React.createElement("title", null, 'Play Icon'),
    React.createElement("path", { fill: "currentColor", d: "M19.622 10.393A105.98 105.98 0 0 0 6.419 3.176c-1.2-.55-2.572.25-2.663 1.558-.167 2.4-.256 4.82-.256 7.262 0 2.444.088 4.868.256 7.27.092 1.307 1.464 2.108 2.663 1.558a106.112 106.112 0 0 0 13.203-7.217 1.91 1.91 0 0 0 0-3.214" }))); };
var Memo = memo(SvgPlay);
export default Memo;
//# sourceMappingURL=Play.js.map